import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CASE_TAKE_REFERENCE_BEGIN,
  CASE_TAKE_REFERENCE_SUCCESS,
  CASE_TAKE_REFERENCE_FAILURE,
  CASE_TAKE_REFERENCE_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { copyExhibitNumberToClipboard } from './copyExhibitNumberToClipboard';
import { withCurrentCaseId } from 'common/selectors';
import { updateDocumentMeta } from './updateDocumentMeta';

export const takeReference = createPromiseAction(
  CASE_TAKE_REFERENCE_BEGIN,
  (fileId, options = {}) => ({
    fileId,
    ...options,
  }),
);

export function dismissTakeReferenceFeedback() {
  return {
    type: CASE_TAKE_REFERENCE_DISMISS_FEEDBACK,
  };
}

export function* doTakeReference(action) {
  const {
    payload: { fileId, caseId },
  } = action;

  const res = yield call(api.post, `/cases/${caseId}/files/${fileId}/exhibit-number`);
  if (res && res.error) {
    yield put({
      type: CASE_TAKE_REFERENCE_FAILURE,
      feedback: {
        message: typeof res.error === 'string' ? res.error : 'case.takeReferenceFailure',
        params: { fileId },
        error: res.error,
        retryAction: action,
      },
      fileId,
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  const exhibitNumber = res?.exhibitNumber ?? res?.data?.exhibitNumber;
  const copyText = exhibitNumber ? `{${exhibitNumber}}` : null;
  const linkHref =
    typeof window !== 'undefined'
      ? `${window.location.origin}/case/${caseId}/files/${fileId}`
      : null;

  if (copyText) {
    yield call(copyExhibitNumberToClipboard, copyText, linkHref);
  }

  const fileMetaPayload = res?.data ?? res;
  if (fileMetaPayload && Object.keys(fileMetaPayload).length) {
    yield put(updateDocumentMeta(fileMetaPayload, fileId));
  }

  yield put({
    type: CASE_TAKE_REFERENCE_SUCCESS,
    feedback: {
      message: 'case.takeReferenceSuccess',
      params: { fileId },
      success: true,
      data: res,
    },
  });
  return yield call(resolvePromiseAction, action, res);
}

export function* watchTakeReference() {
  yield takeEvery(takeReference, withCurrentCaseId(doTakeReference));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_TAKE_REFERENCE_BEGIN + '.TRIGGER':
      return {
        ...state,
        takeReferencePending: true,
        takeReferenceFeedback: null,
        takeReferenceResult: null,
      };

    case CASE_TAKE_REFERENCE_SUCCESS:
      return {
        ...state,
        takeReferencePending: false,
        takeReferenceFeedback: action.feedback,
        takeReferenceResult: action.feedback?.data,
      };

    case CASE_TAKE_REFERENCE_FAILURE:
      return {
        ...state,
        takeReferencePending: false,
        takeReferenceFeedback: action.feedback,
        takeReferenceResult: null,
      };

    case CASE_TAKE_REFERENCE_DISMISS_FEEDBACK:
      return {
        ...state,
        takeReferenceFeedback: null,
        takeReferenceResult: null,
      };

    default:
      return state;
  }
}
